// src/components/AddCompanyForm/CompanyEssentialsCard.jsx
import React from "react";
import { Card, CardHeader, CardContent, Grid, TextField, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function CompanyEssentialsCard({
  form,
  setForm,
  isCreate = false,
  onSlugInput,
  onSlugBlur,
}) {
  const { t } = useTranslation("settings");
  const set = (patch) => setForm((p) => ({ ...p, ...patch }));

  return (
    <Card variant="outlined">
      <CardHeader
        title={t("addCompanyForm.essentials.title")}
        subheader={t("addCompanyForm.essentials.subheader")}
      />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <TextField
              label={t("addCompanyForm.identity.nameLabel")}
              value={form.nome}
              onChange={(e) => set({ nome: e.target.value })}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              select
              label={t("addCompanyForm.identity.statusLabel")}
              value={form.status}
              onChange={(e) => set({ status: Number(e.target.value) })}
              fullWidth
              required
            >
              <MenuItem value={1}>{t("shared.active")}</MenuItem>
              <MenuItem value={0}>{t("shared.inactive")}</MenuItem>
            </TextField>
          </Grid>

          {isCreate && typeof onSlugInput === "function" && (
            <Grid item xs={12}>
              <TextField
                label={t("addCompanyForm.identity.slugLabel")}
                value={form.codigo_interno ?? ""}
                onChange={(e) => onSlugInput(e.target.value)}
                onBlur={() => onSlugBlur?.()}
                fullWidth
                placeholder={t("addCompanyForm.identity.slugPlaceholder")}
                helperText={t("addCompanyForm.identity.slugAutoHint")}
                inputProps={{ maxLength: 60 }}
              />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}
